<section class="container">
    <div class="login-section">
        <div class="login-header">
            <img alt="app-logo" class="app-logo" src="assets/icons/seller-logo.png" />
        </div>
        <div class="welcome-part">
            <h4 class="welcome-title">مرحبًا بعودتك</h4>
            <p class="welcome-paragraph">الرجاء إدخال التفاصيل الخاصة بك لتسجيل الدخول</p>
        </div>
        <div class="credentials-part col-md-6">
            <form (ngSubmit)="login()" [formGroup]="form">
                <!-- USER NAME -->
                <div class="d-flex flex-column gap-2 mb-3">
                    <label for="username">الايميل</label>
                    <input
                        aria-describedby="username-help"
                        autocomplete="off"
                        class="p-inputtext-sm"
                        formControlName="email"
                        id="username"
                        pInputText />
                </div>
                <!-- USER NAME -->
                <div class="d-flex flex-column gap-2 mb-4">
                    <label for="password">كلمة المرور</label>
                    <input
                        aria-describedby="username-help"
                        autocomplete="off"
                        class="p-inputtext-sm"
                        formControlName="password"
                        id="password"
                        pInputText
                        type="password" />
                </div>
                <div class="text-center my-2">{{ message }}</div>
                <div class="submit-form full-width">
                    <p-button
                        [disabled]="form.invalid || loginInProgress"
                        [icon]="loginInProgress ? 'pi pi-spin pi-spinner' : ''"
                        class="w-100"
                        label="تسجيل الدخول"
                        type="submit"></p-button>
                </div>
            </form>
            <!-- DONT HAVE ACCOUNT -->
<!--            <div class="register-redirection">-->
<!--                <small>ليس لديك حساب؟ <a class="m-1 text-primary-600" routerLink="/auth/register">سجل الان</a></small>-->
<!--            </div>-->
            <!-- FORGOT PASSWORD -->
            <div class="register-redirection">
                <small><a class="m-1 text-primary-600" routerLink="/auth/forgot-password">نسيت كلمة المرور؟</a></small>
            </div>
            <!--      <button pButton (click)='authService.logout()'>LOGOUT</button>-->
        </div>
    </div>
</section>
